import { render, staticRenderFns } from "./CampusTravelFields.vue?vue&type=template&id=f0e7c048&scoped=true"
import script from "./CampusTravelFields.vue?vue&type=script&lang=js"
export * from "./CampusTravelFields.vue?vue&type=script&lang=js"
import style0 from "./CampusTravelFields.vue?vue&type=style&index=0&id=f0e7c048&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e7c048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0e7c048')) {
      api.createRecord('f0e7c048', component.options)
    } else {
      api.reload('f0e7c048', component.options)
    }
    module.hot.accept("./CampusTravelFields.vue?vue&type=template&id=f0e7c048&scoped=true", function () {
      api.rerender('f0e7c048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/CampusTravelFields.vue"
export default component.exports